import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Modal, Avatar, Text, Group, SimpleGrid, Loader, Box } from '@mantine/core'
import { Profile } from '../../app/models/profile'
import { useStore } from '../../app/stores/store'

interface Props {
  username: string;
  opened: boolean;
  onClose: () => void;
  mode: 'followers' | 'following';
}

export default observer(function FollowersModal ({ username, opened, onClose, mode }: Props) {
  const { profileStore } = useStore()
  const [list, setList] = useState<Profile[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!opened || !username) return
    setLoading(true);
    (mode === 'followers' ? profileStore.loadFollowers(username) : profileStore.loadFollowing(username))
      .then((data) => setList(data))
      .catch(() => setList([]))
      .finally(() => setLoading(false))
  }, [opened, username, mode, profileStore])

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={mode === 'followers' ? 'Followers' : 'Following'}
      size="md"
    >
      {loading
        ? (
        <Box py="xl" sx={{ display: 'flex', justifyContent: 'center' }}>
          <Loader size="sm" />
        </Box>
          )
        : list.length === 0
          ? (
        <Text color="dimmed" size="sm" py="xl">
          {mode === 'followers' ? 'No followers yet' : 'Not following anyone yet'}
        </Text>
            )
          : (
        <SimpleGrid cols={1} spacing="sm">
          {list.map((p) => (
            <Group
              key={p.username}
              component={Link}
              to={`/profiles/${p.username}`}
              onClick={onClose}
              sx={{ textDecoration: 'none', color: 'inherit', '&:hover': { backgroundColor: 'rgba(0,0,0,.04)' } }}
              p="xs"
              style={{ borderRadius: 8 }}
            >
              <Avatar
                src={p.image || '/assets/user.png'}
                alt={p.displayName}
                radius="xl"
                size={40}
              />
              <div>
                <Text size="sm" weight={600}>
                  {p.displayName}
                </Text>
                <Text size="xs" color="dimmed">
                  @{p.username}
                </Text>
              </div>
            </Group>
          ))}
        </SimpleGrid>
            )}
    </Modal>
  )
})
